export const dispatchDidMount = (vNode) => {
    if (vNode.type !== 'ELEMENT')
        return;
    vNode.children.forEach(dispatchDidMount);
    vNode.lifeEvents.didMount?.(vNode._el);
    vNode.lifeEvents.didMount = undefined;
};
